module.exports = __webpack_public_path__ + "img/DE05817.81605585.png";